export { default } from './FreemiumSplug';
